import _typeof from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/typeof.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.is-array.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.join.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.push.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.regexp.exec.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.search.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import { __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect } from 'react';
import { RightOutline } from 'antd-mobile-icons';
import { isFunction } from 'lodash';
import { TiList } from '../../TiList/index.js';
import TiSearchBar from '../../TiSearchBar/SearchBar/index.js';
import useLanguage from '../../hooks/useLangugle/index.js';
import { TiModal } from '../../TiModal/index.js';
import '../styles/index.less.js';

var TiSelectPage = function TiSelectPage(props) {
  var CommonLocale = useLanguage('Common');
  var title = props.title,
    _a = props.okText,
    okText = _a === void 0 ? CommonLocale.confirm : _a,
    trigger = props.trigger,
    _b = props.type,
    type = _b === void 0 ? 'single' : _b,
    _c = props.disabled,
    disabled = _c === void 0 ? false : _c,
    value = props.value,
    onChange = props.onChange,
    search = props.search,
    _d = props.immediately,
    immediately = _d === void 0 ? false : _d,
    _e = props.allowClear,
    allowClear = _e === void 0 ? true : _e,
    checkItemProps = props.checkItemProps,
    onClose = props.onClose,
    _f = props.rowKey,
    rowKey = _f === void 0 ? 'id' : _f,
    _g = props.showKey,
    showKey = _g === void 0 ? 'label' : _g,
    _h = props.placeholder,
    placeholder = _h === void 0 ? CommonLocale.pleaseSelect : _h,
    _j = props.presetItemStyle,
    presetItemStyle = _j === void 0 ? 'card' : _j,
    _k = props.destroyOnClose,
    destroyOnClose = _k === void 0 ? true : _k;
  var control = TiModal.useControl();
  // 获取默认展示的selectedValue的值
  var getDefaultSelectedValues = function getDefaultSelectedValues(val) {
    var _rowKey = isFunction(rowKey) ? rowKey(val) : rowKey;
    if (typeof val === 'string' || typeof val === 'number') {
      var foo = {};
      foo[_rowKey] = val;
      foo[showKey] = val;
      return foo;
    } else if (Array.isArray(val)) {
      return val;
    } else if (_typeof(val) === 'object') {
      return val;
    }
    return undefined;
  };
  var _l = useState(getDefaultSelectedValues(value)),
    selectedValue = _l[0],
    setSelect = _l[1];
  var _m = useState({}),
    searchParams = _m[0],
    setSearchParams = _m[1];
  var ref = useRef({});
  var searchBarRef = useRef({});
  var closeModal = function closeModal() {
    var _a, _b;
    control.onClose();
    if ((_a = searchBarRef === null || searchBarRef === void 0 ? void 0 : searchBarRef.current) === null || _a === void 0 ? void 0 : _a.onDropClose) {
      (_b = searchBarRef === null || searchBarRef === void 0 ? void 0 : searchBarRef.current) === null || _b === void 0 ? void 0 : _b.onDropClose();
    }
    if (onClose) {
      onClose();
    }
    setSearchParams({});
  };
  var openModal = function openModal() {
    if (disabled) {
      return;
    }
    control.onOpen();
  };
  var triggerProps = {
    onClick: function onClick() {
      openModal();
    }
  };
  var getValueShow = function getValueShow(val) {
    if (!val) {
      return undefined;
    } else if (typeof val === 'string') {
      return val;
    } else if (Array.isArray(val)) {
      var textArr_1 = [];
      val.forEach(function (v) {
        textArr_1.push(getValueShow(v));
      });
      return textArr_1.join(',');
    } else if (_typeof(val) === 'object') {
      return val === null || val === void 0 ? void 0 : val.label;
    }
  };
  var defaultTrigger = function defaultTrigger() {
    var dom = /*#__PURE__*/React.createElement("div", null);
    if (disabled) {
      dom = /*#__PURE__*/React.createElement("div", {
        className: "ti-form-trigger ".concat(getValueShow(value) ? '' : 'ti-form-trigger-placeholder', " ti-form-disable")
      }, /*#__PURE__*/React.createElement("div", {
        className: "ti-form-trigger-inner"
      }, getValueShow(value) || placeholder), /*#__PURE__*/React.createElement(RightOutline, null));
    } else {
      dom = /*#__PURE__*/React.createElement("div", {
        className: "ti-form-trigger ".concat(getValueShow(value) ? '' : 'ti-form-trigger-placeholder')
      }, /*#__PURE__*/React.createElement("div", {
        className: "ti-form-trigger-inner"
      }, getValueShow(value) || placeholder), /*#__PURE__*/React.createElement(RightOutline, null));
    }
    return /*#__PURE__*/React.cloneElement(dom, triggerProps);
  };
  var onSubmit = function onSubmit(v) {
    setSelect(v);
    if (onChange && (v || allowClear)) {
      onChange(v);
      closeModal();
    }
  };
  var getItemDisable = function getItemDisable(item) {
    var _a;
    if (checkItemProps === null || checkItemProps === void 0 ? void 0 : checkItemProps.disabled) {
      return (_a = checkItemProps === null || checkItemProps === void 0 ? void 0 : checkItemProps.disabled(item)) !== null && _a !== void 0 ? _a : false;
    }
    return false;
  };
  var _onItemClick = function onItemClick(item, rows) {
    setSelect(rows !== null && rows !== void 0 ? rows : undefined);
    if (onChange && immediately && type === 'single') {
      onChange(rows !== null && rows !== void 0 ? rows : undefined);
      closeModal();
    }
  };
  var defaultItemRender = function defaultItemRender(item, active) {
    if (checkItemProps === null || checkItemProps === void 0 ? void 0 : checkItemProps.itemRender) {
      return /*#__PURE__*/React.createElement("div", null, checkItemProps === null || checkItemProps === void 0 ? void 0 : checkItemProps.itemRender(item, {
        active: active
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-select-page-item-check"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ti-select-page-item-name"
    }, item[showKey]));
  };
  /**
   * value 发生变化 - 对应的值也发生变化
   */
  useEffect(function () {
    if (value) {
      setSelect(value);
    } else {
      setSelect(undefined);
    }
  }, [value]);
  var onConfigChange = function onConfigChange(changed) {
    var _a;
    var keyword = changed.keyword,
      key = changed.key;
    if (keyword === '') {
      setSearchParams({});
    }
    setSearchParams((_a = {}, _a[key] = keyword, _a));
  };
  var onSearchBarSearch = function onSearchBarSearch() {
    var _a;
    (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.onSearch();
  };
  var getModalActions = function getModalActions() {
    var actions = [];
    if (!immediately) {
      actions.push({
        key: 'reset',
        title: CommonLocale.reset,
        color: 'default',
        onClick: function onClick() {
          setSelect(undefined);
          if (immediately && type === 'single') {
            onSubmit(undefined);
          }
        }
      });
    }
    if (!immediately || type === 'multiple') {
      actions.push({
        disabled: !selectedValue && !allowClear,
        key: 'confirm',
        title: okText,
        color: 'primary',
        onClick: function onClick() {
          onSubmit(selectedValue);
        }
      });
    }
    return actions;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, trigger ? /*#__PURE__*/React.cloneElement(trigger(value), triggerProps) : defaultTrigger(), /*#__PURE__*/React.createElement(TiModal.Right, {
    title: title,
    visible: control.visible,
    onClose: closeModal,
    onOpen: openModal,
    bodyStyle: {
      background: '#fff',
      overflow: 'hidden'
    },
    destroyOnClose: destroyOnClose,
    actions: getModalActions()
  }, search.configs ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '0px 8px'
    }
  }, /*#__PURE__*/React.createElement(TiSearchBar, {
    configs: search === null || search === void 0 ? void 0 : search.configs,
    ref: searchBarRef,
    showSearchText: true,
    onConfigChange: onConfigChange,
    onSearch: onSearchBarSearch
  })) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'auto',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(TiList.Select, {
    ref: ref,
    selectType: type,
    request: function request(p) {
      var defaultParams = {};
      if (search === null || search === void 0 ? void 0 : search.defaultParams) {
        defaultParams = search === null || search === void 0 ? void 0 : search.defaultParams;
      }
      return search === null || search === void 0 ? void 0 : search.api(__assign(__assign(__assign({}, p), defaultParams), searchParams));
    },
    rowKey: rowKey,
    presetItemStyle: presetItemStyle,
    selectedRow: selectedValue,
    onItemClick: function onItemClick(data, rows) {
      var disabled = getItemDisable(data);
      if (!disabled) {
        _onItemClick(data, rows);
      }
    },
    renderItem: function renderItem(data, index, config) {
      return {
        node: defaultItemRender(data, config.active),
        config: {
          disabled: getItemDisable(data)
        }
      };
    }
  }))));
};

export { TiSelectPage as default };
